<template>
  <b-form class="px-2 mb-3">
    <b-row>
      <b-col lg="3">
        <b-form-group
          label="Product Images"
          label-class="product-creation-section-labels py-0"
        >
          <small class="sub-section-labels">Upload at least 1 image</small>
        </b-form-group>
      </b-col>
      <b-col lg="5">
        <b-form-group
          :state="!formValidatedState('product_images')"
          :invalid-feedback="apiErrors.product_images"
        >
          <div
            class="product-images-container p-3 text-center position-relative"
          >
            <span v-if="productImages.length < 10">
              Drag your image here or
              <strong class="text-primary">browse file</strong>
            </span>
            <div
              class="uploaded-images-container mt-3 d-flex justify-content-center"
              v-if="productImages.length"
            >
              <div class="grid-view" :style="gridRowCount">
                <div
                  class="single-img-container rounded overflow-hidden justify-content-center position-relative flex-shrink-0 d-flex"
                  v-for="(image, imageIndex) in productImages"
                  :key="`product-image-${imageIndex}`"
                >
                  <i
                    v-if="productImages.length > 1"
                    class="bi bi-trash rounded-circle position-absolute d-flex align-items-center justify-content-center"
                    aria-hidden="true"
                    @click="removeImage(image.index)"
                  >
                  </i>
                  <img
                    :src="image.image"
                    :alt="`product-image-${imageIndex}`"
                    class="h-100"
                  />
                </div>
              </div>
            </div>
            <b-form-file
              plain
              accept=".jpg, .png, .gif"
              id="upload-product-images"
              class="position-absolute w-100"
              v-model="productImage"
              @input="getImages"
              ref="productImageUpload"
              v-if="productImages.length < 10"
            >
            </b-form-file>
          </div>
          <div class="counter-container mt-1 d-flex justify-content-between">
            {{ message }}
            <span> {{ productImages.length }} / 10 uploaded</span>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <ProductImageUpload
      :values="product_img_upload"
      :initial-value="chosenFile"
      @clearImage="clearImage"
    />
  </b-form>
</template>

<script>
import { mapState } from "vuex";
import ProductImageUpload from "./ProductImageUpload";
import { productsMixins } from "@/mixins/products_mixins";

export default {
  components: { ProductImageUpload },
  data() {
    return {
      message: "Recommended Size: 638 x 310px",
      product_img_upload: {
        croppa: {},
        sliderVal: 0,
        sliderMin: 0,
        sliderMax: 0,
      },
      chosenFile: null,
      productImage: null,
    };
  },
  computed: {
    ...mapState("products", ["product_images", "errors"]),
    productImages() {
      return this.product_images.filter(image => image.action !== "delete");
    },
    gridRowCount: {
      get() {
        let row_count = 2;
        const images_count = this.product_images.length;
        if (images_count > 5 && images_count <= 9) row_count = 3;
        else if (images_count === 10) row_count = 4;

        return {
          "--row-count": row_count,
        };
      },
      set(count) {
        return count;
      },
    },
  },
  mixins: [productsMixins],
  methods: {
    async getImages(image) {
      const acceptedFileTypes = ["jpg", "jpeg", "png", "gif"];
      let type;
      if (image) {
        type = image.type;

        if (acceptedFileTypes.includes(type.split("/").pop())) {
          this.chosenFile = await this.getImageBase64(image);
          this.$root.$emit("bv::show::modal", "inventoryUploadImages");
        } else console.log("Invalid file type");
      }
    },
    getImageBase64(image, onLoadCallback) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(image);
      });
    },
    removeImage(imageIndex) {
      const product_image = this.product_images.find(image => image.index === imageIndex);
      this.$store.commit("products/removeImage", {
        action: "delete",
        index: imageIndex,
      });
    },
    clearImage() {
      this.productImage = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.product-images-container {
  border-radius: 12px;
  border: 1px dashed #d8dcde;
  font-size: 14px;
  color: #2f3941;
  & > strong {
    font-size: 14px;
  }
}
#upload-product-images {
  top: 0;
  left: 0;
  background: red;
  height: 45px;
  opacity: 0;
  cursor: pointer;
}
.uploaded-images-container {
  .single-img-container {
    .bi.bi-trash {
      width: 28px;
      height: 28px;
      top: 10px;
      right: 10px;
      color: #fff;
      background: rgba(0, 0, 0, 0.3);
      cursor: pointer;
      display: none !important;
      transition: all 0.3s ease;
    }
    &:hover {
      .bi.bi-trash {
        display: inherit !important;
      }
    }
  }
  .grid-view {
    margin: auto;
    display: grid;
    grid-template-columns: repeat(4, 75px);
    grid-template-rows: repeat(var(--row-count), 75px);
    gap: 10px;
    .single-img-container {
      &:first-child {
        grid-column-start: 1;
        grid-column-end: span 2;
        grid-row-start: 1;
        grid-row-end: span 2;
      }
      &:nth-child(10) {
        grid-column-start: 3;
        grid-column-end: span 2;
        grid-row-start: 3;
        grid-row-end: span 2;
      }
    }
  }
}
</style>
